/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */

import { Component, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { UsersService } from '../../services/users.service';

import { ConnectedUserModel } from '../../interfaces/users-models';

@Component({
  selector: 'app-home',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnDestroy {
  connectedUser: ConnectedUserModel | null;
  isLoading = true;

  private usersService: UsersService;
  private subsCleanup: Subscription[] = [];

  constructor() {
    this.usersService = inject(UsersService);
    this.connectedUser = this.usersService.getConnectedUserSync();
  }

  ngOnDestroy(): void {
    for (const currSub of this.subsCleanup) {
      currSub.unsubscribe();
    }
  }
}
